import React, { useContext } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";

import { AuthContext } from "../context/Auth/AuthContext";
import BackdropLoading from "../components/BackdropLoading";
import ModuleGuard from "../components/ModuleGuard";
import { WhatsAppsProvider } from "../context/WhatsApp/WhatsAppsContext";
import LoggedInLayout from "../layout";

// No react-router 7 não existe mais o <Route component>: quem decide se a
// rota abre é um elemento de layout que devolve <Outlet /> ou <Navigate />.

// Enquanto `loading` é true a sessão ainda está sendo restaurada (o
// refresh_token está em voo) e `isAuth` ainda é false por padrão. Decidir
// nesse instante manda todo mundo para o login a cada F5 — a sessão existia,
// só não tinha chegado a resposta. Espera-se a renovação antes de decidir.
export const PublicRoute = () => {
  const { isAuth, loading } = useContext(AuthContext);
  const location = useLocation();

  if (loading) return <BackdropLoading />;

  if (isAuth) {
    return <Navigate to="/" replace state={{ from: location }} />;
  }

  return <Outlet />;
};

export const PrivateRoutes = () => {
  const { isAuth, loading } = useContext(AuthContext);
  const location = useLocation();

  if (loading) return <BackdropLoading />;

  if (!isAuth) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return (
    <>
      <WhatsAppsProvider>
        <LoggedInLayout>
          {/* Rota de módulo não contratado explica o motivo em vez de abrir
              uma tela vazia que o backend recusa a preencher. */}
          <ModuleGuard caminho={location.pathname}>
            <Outlet />
          </ModuleGuard>
        </LoggedInLayout>
      </WhatsAppsProvider>
    </>
  );
};
